import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "./baseQuery";
import { IInquiry } from "../../types";

// Response types (you can adjust these based on your actual API response)
export interface AuthResponse {
  token: string;
  user: {
    id: string;
    name: string;
    email: string;
    [key: string]: any;
  };
}

export interface GenericResponse {
  message: string;
}

interface InquiryResponse {
  data: { inquiryCount: number; inquiryList: IInquiry[] };
}

interface InquiryDetailsResponse {
  data: {
    inquiry: any;
  };
}

export const inquiryApi = createApi({
  reducerPath: "inquiryApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getInquiryList: builder.query<
      InquiryResponse,
      { page: number; search?: string }
    >({
      query: ({ page, search }) => {
        let url = `/inquiry/list?pageNumber=${page}&pageSize=10`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        return {
          url,
          method: "GET",
        };
      },
    }),
    getInquiryDetails: builder.query<InquiryDetailsResponse, number>({
      query: (inquiryId) => ({
        url: `/inquiry/details?inquiryId=${inquiryId}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetInquiryListQuery, useGetInquiryDetailsQuery } = inquiryApi;
